const initialState = {
  categoriesLoading: false,
  isError: false,
  categories: [],
  userQuestions: {},
};

const AskQuestionReducer = (state = { initialState }, action) => {
  switch (action?.type) {
    case "GET_CATEGORIES_REQUEST":
      return { ...state, categoriesLoading: true };
    case "GET_CATEGORIES_RESPONSE":
      return {
        ...state,
        categories: action?.payload,
        categoriesLoading: false,
      };
    case "GET_CATEGORIES_ERROR":
      return {
        ...state,
        categoriesLoading: false,
        isError: true,
        error: action?.payload,
      };
    case "GET_QUESTIONS_REQUEST":
      return { ...state, questionsLoading: true };
    case "GET_QUESTIONS_RESPONSE":
      return {
        ...state,
        userQuestions: action?.payload,
        questionsLoading: false,
      };
    case "GET_QUESTIONS_ERROR":
      return {
        ...state,
        questionsLoading: false,
        isError: true,
        error: action?.payload,
      };

    case "ADD_QUESTION":
      return {
        ...state,
        userQuestions: {
          ...state?.userQuestions,
          recentThreads: [
            { ...action?.payload },
            ...state?.userQuestions?.recentThreads,
          ],
        },
      };
    case "DELETE_QUESTION_REQUEST":
      return {
        ...state,
        questionsLoading: true,
      };
    case "DELETE_QUESTION_RESPONSE":
      let updatedRecentThreads = state?.userQuestions?.recentThreads.filter(
        (Id) => {
          return action?.payload?.result?.id !== Id?.threadsId;
        }
      );
      let updatedAnswerThreads = state?.userQuestions?.answerThreads.filter(
        (Id) => {
          return action?.payload?.result?.id !== Id?.threadsId;
        }
      );

      return {
        ...state,
        userQuestions: {
          ...state?.userQuestions,
          recentThreads: [...updatedRecentThreads],
          answerThreads: [...updatedAnswerThreads],
        },
        questionsLoading: false,
      };
    case "DELETE_QUESTION_ERROR":
      return {
        ...state,
        questionsLoading: false,
        isError: true,
        error: action?.payload,
      };
    default:
      return state;
  }
};

export default AskQuestionReducer;
